import React, { Component } from 'react';

import { SecondsToMMSS } from '../../../common/constant';

export class Timer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: parseInt(props.initialTime || 0, 10),
      stopTimerOnBtnClick: false,
      disabled: false,
    };
  }
  timerToggle = () => {
    const { stopTimerOnBtnClick } = this.state;
    if (stopTimerOnBtnClick) {
      clearInterval(this.timer);
    } else {
      clearInterval(this.timer);
      this.timer = setInterval(this.tick, 1000);
    }
  };

  tick = () => {
    this.setState(prevState => ({ count: prevState.count + 1 }), () => {
      if (this.props.getTimerValue) {
        this.props.getTimerValue(this.state.count);
      }
    });
  };
  componentDidMount() {
    if (!this.props.stopTimer) {
      this.timer = setInterval(this.tick, 1000);
    }
  }
  componentWillUnmount() {
    clearInterval(this.timer);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.stopTimer !== this.props.stopTimer) {
      if (this.props.stopTimer) {
        this.setState({ stopTimerOnBtnClick: true, disabled: true }, () => {
          this.timerToggle();
        });
      } else {
        this.setState({ stopTimerOnBtnClick: false, disabled: false }, () => {
          this.timerToggle();
        });
      }
    }
    if (prevProps.initialTime !== this.props.initialTime) {
      this.setState({ count: parseInt(this.props.initialTime || 0, 10) });
    }
  }

  render() {
    const { count, stopTimerOnBtnClick, disabled } = this.state;
    const { stopTimer } = this.props;
    return (
      <div>
        <div className='timer_outer'>
          <i className='fa fa-clock-o' />
          <span className='timer_box'>{SecondsToMMSS(count)}</span>
        </div>

        <button
          type='button'
          className={`pause_btn ${
            stopTimerOnBtnClick || stopTimer ? 'icon-control-play' : 'icon-control-pause'
          }`}
          onClick={() =>
            this.setState(
              {
                stopTimerOnBtnClick: !stopTimerOnBtnClick,
              },
              () => {
                this.timerToggle();
              },
            )
          }
          disabled={disabled || stopTimer}
        />
      </div>
    );
  }
}

export default Timer;



// WEBPACK FOOTER //
// ./src/views/ESG/Timer/index.jsx